export default "__VITE_ASSET__418b96e6__"